import styled from "styled-components";

export const FooterBox = styled.footer`
  background-color: #101522;
`;

export const SocialWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 1100px;
  margin: 0 auto;
`;

export const LinkItems = styled.div`
  display: flex;
  justify-content: space-around;
  margin: 16px;
  width: 480px;
  box-sizing: border-box;
  color: #fff;

  @media screen and (max-width: 420px) {
    margin: 0;
    padding: 10px;
    width: 100%;
  }
`;

export const LinkItem = styled.a`
  color: #fff;
  text-decoration: none;
  font-size: 3rem;
  cursor: pointer;

  &:hover {
    color: #01bf71;
    transition: 0.3 ease-out;
  }
`;
